module.exports = entcore;


//////////////////
// WEBPACK FOOTER
// external "entcore"
// module id = 1
// module chunks = 0 1